import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSsosKey } from '../../utils/keys';
export const useUpdateCustomSso = (options) => {
    const { useMutationOptions } = options || {};
    const queryClient = useQueryClient();
    const { client } = useTribeClient();
    return useMutation(input => client.auth.updateCustomSso(input), {
        onSettled: () => {
            const ssosKey = getSsosKey();
            queryClient.invalidateQueries(ssosKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateCustomSso.js.map